var colors = {
  transparent: 'transparent',
  current: 'currentColor',
  inherit: 'inherit',
  white: '#FFFFFF',
  black: '#000000',
  'white-100': '#FEFEFE',
  'white-200': '#F6F6F6',
  'gray-100': '#EBEBEB',
  'gray-200': '#DEDEDE',
  'gray-300': '#BDBDBD',
  'gray-400': '#858585',
  'gray-500': '#716F6F',
  'gray-600': '#4F4F4F',
  'gray-700': '#333333',
  'gray-800': '#1F1F20',
  'navyblue-100': '#86A3C3',
  'navyblue-200': '#4F627C',
  'navyblue-300': '#3E516B',
  'navyblue-350': '#30415C',
  'navyblue-400': '#23344E',
  'navyblue-500': '#1D2A3F',
  'navyblue-600': '#192231',
  'navyblue-700': '#141C2A',
  'navyblue-800': '#0F1623',
  'blue-100': '#ACE2FF',
  'blue-200': '#7FD3FF',
  'blue-300': '#11A5F3',
  'blue-400': '#0081C5',
  'blue-500': '#0B5297',
  'blue-600': '#073E73',
  'blue-700': '#042E57',
  'blue-800': '#032241',
  'teal-100': '#91EDDC',
  'teal-200': '#56E3C9',
  'teal-300': '#35C6AB',
  'teal-400': '#14B597',
  'teal-500': '#09A084',
  'teal-600': '#006A68',
  'teal-700': '#005553',
  'teal-800': '#004140',
  'cyan-100': '#A4F8FF',
  'cyan-200': '#73F4FF',
  'cyan-300': '#3ED2DE',
  'cyan-400': '#29BAC6',
  'cyan-500': '#169CA7',
  'cyan-600': '#007A84',
  'cyan-700': '#115469',
  'cyan-800': '#043C4D',
  'indigo-100': '#CED3EC',
  'indigo-200': '#B4BCE2',
  'indigo-300': '#96A0D5',
  'indigo-400': '#7985CC',
  'indigo-500': '#5D6AC0',
  'indigo-600': '#4C579F',
  'indigo-700': '#3B457B',
  'indigo-800': '#2A3158',
  'violet-100': '#B8B1DE',
  'violet-200': '#9F97CA',
  'violet-300': '#8178B3',
  'violet-400': '#7268A6',
  'violet-500': '#5A508A',
  'violet-600': '#473D77',
  'violet-700': '#3D3065',
  'violet-800': '#322558',
  'purple-100': '#BB74C8',
  'purple-200': '#AD64BA',
  'purple-300': '#9E51AB',
  'purple-400': '#894195',
  'purple-500': '#6E3078',
  'purple-600': '#5A2164',
  'purple-700': '#4D1A56',
  'purple-800': '#43134C',
  'magenta-100': '#F652B1',
  'magenta-200': '#D93896',
  'magenta-300': '#B81C77',
  'magenta-400': '#9E1364',
  'magenta-500': '#82074F',
  'magenta-600': '#6D0341',
  'magenta-700': '#590134',
  'magenta-800': '#49002B',
  'pink-100': '#F3A7BA',
  'pink-200': '#F48BA6',
  'pink-300': '#EB7795',
  'pink-400': '#DB6684',
  'pink-500': '#C55773',
  'pink-600': '#AC4A63',
  'pink-700': '#87374B',
  'pink-800': '#662737',
  'red-100': '#FF7577',
  'red-200': '#E85959',
  'red-300': '#D64242',
  'red-400': '#C82727',
  'red-500': '#AF0003',
  'red-600': '#850003',
  'red-700': '#490001',
  'red-800': '#390001',
  'orange-100': '#FF987D',
  'orange-200': '#FF7C5A',
  'orange-300': '#FF673F',
  'orange-400': '#EB522A',
  'orange-500': '#D44621',
  'orange-600': '#9C3B21',
  'orange-700': '#713323',
  'orange-800': '#57291D',
  'yellow-100': '#FFDD9B',
  'yellow-200': '#FFCB66',
  'yellow-300': '#FFC147',
  'yellow-400': '#FFB41E',
  'yellow-500': '#FFA500',
  'yellow-600': '#E98702',
  'yellow-700': '#B35D00',
  'yellow-800': '#804301',
  'green-100': '#C9E3A1',
  'green-200': '#ACD46E',
  'green-300': '#98C356',
  'green-400': '#67B52C',
  'green-500': '#50931D',
  'green-600': '#25470C',
  'green-700': '#183105',
  'green-800': '#152707'
};
export default colors;